import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'BaseBottomSheet',
  props: {
    show: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})